import App from "./src/App";

App();
